import { NgModule } from '@angular/core';

// Components
import { EmptyComponent } from '../components/empty.component';
import { NoAccessComponent } from '../components/no-access.component';
import { SpinnerComponent } from '../components/spinner.component';

// Directives
import { FocusDirective } from '../directives/focus.directive';
import { MustBeDifferentThanValidatorDirective } from '../directives/must-be-different-than.directive';
import { NumericInputDirective } from '../directives/numeric-input.directive';
import { StatusDirective } from '../directives/status.directive';

// Pipes
import { HiddenFilterPipe } from '../pipes/hidden.pipe';
import { SpecCategoryFilterPipe } from '../pipes/spec-category.pipe';
import { VehicleTypeFilterPipe } from '../pipes/vehicle-type.pipe';

// Validators
import { mustBeDifferentThanValidator } from '../validators/must-be-different-than';

@NgModule({
    declarations: [
        EmptyComponent,
        NoAccessComponent,
        SpinnerComponent,
        FocusDirective,
        MustBeDifferentThanValidatorDirective,
        HiddenFilterPipe,
        SpecCategoryFilterPipe,
        VehicleTypeFilterPipe,
        NumericInputDirective,
        StatusDirective
    ],
    imports: [],
    exports: [
        EmptyComponent,
        NoAccessComponent,
        SpinnerComponent,
        FocusDirective,
        MustBeDifferentThanValidatorDirective,
        HiddenFilterPipe,
        SpecCategoryFilterPipe,
        VehicleTypeFilterPipe,
        NumericInputDirective,
        StatusDirective
    ],
    providers: [
    ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/shared.module.ts